import React from 'react'
import { Pagination } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

import '../../index.css'

const Paginate = ({ page, pages, forSystemOwner }) => {
  return (
    pages > 1 && (
      <Pagination>
        {[...Array(pages).keys()].map((x) => (
          <LinkContainer
            key={x + 1}
            to={
              forSystemOwner
                ? `/systemowner/studies/${x + 1}`
                : `/studies/${x + 1}`
            }
          >
            <Pagination.Item
              className={'paginationItemStyle'}
              active={x + 1 === page}
            >
              {x + 1}
            </Pagination.Item>
          </LinkContainer>
        ))}
      </Pagination>
    )
  )
}

export default Paginate
